module.exports = __webpack_public_path__ + "static/media/personalPage3x.69c7a82d.jpg";